// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryTileList_container__1z5aR","heading":"CategoryTileList_heading__OkUjU"};